import type { VesselDataDashboard, VesselDataSummary } from "../models/vessel-data.models";

export const VESSEL_DATA_MOCK_VESSELS: VesselDataSummary[] = [
  { imoNumber: "9853890", vesselName: "CSSC AMSTERDAM", vesselType: "PANAMAX", dwt: 120566 },
  { imoNumber: "9460588", vesselName: "SEA JUNO", vesselType: "PANAMAX", dwt: 76000 },
];

const csscAmsterdamDashboard: VesselDataDashboard = {
  vessel: {
    ...VESSEL_DATA_MOCK_VESSELS[0],
    designIhs: null,
    designDvp: "Huangpu CSSC Baby Cape",
    engineTypeIhs: "6G60ME-C9",
    engineTypeDvp: "6G60ME",
    scrubberDvp: true,
    scrubberImos: "Open Loop",
    includeInVesselCard: true,
    email: "MASTER@CSSCAMSTERDAM.WAHKWONG.COM.HK",
    ballastDraftCorrection: null,
    ladenDraftCorrection: 14.5,
    ballastDraftCoefficient: 0.2,
    ladenDraftCoefficient: null,
    refAe: 3.3,
    mcrLimit: 0,
    mcrIhs: 16080,
    mcrDvp: 11600,
    minMcr: 50,
    maxMcr: 85,
    esd: "PBCF, VFD, LEDs",
    ghgRating: "A",
    ghgVerified: true,
    ghgRatingInput: null,
    ghgEvdi: 2.81,
    ghgEexiStatus: "NotRequired",
    ghgEexi: null,
    safetyScore: 2,
    build: "2020-09",
    buildCountry: "China",
    keelDate: "2015-12",
    yard: "Huangpu Wenchong Longxue",
    engineMaker: "Unknown",
    shipManager: "CSSC Hong Kong Shipping",
    technicalManager: "Wah Kwong Ship Management HK",
  },
  performance: [
    { condition: "ladenEco", cleanHullSpeed: 12.4, totalConsumption: 33.3, currentSpeed: 12.4, currentVsCleanPercent: 100, cpSpeed: 12, cpConsumption: 33.2, cleanPerformance: "Within + 0.5 kn", currentPerformance: "Within + 0.5 kn" },
    { condition: "ballastEco", cleanHullSpeed: 13.3, totalConsumption: 31.8, currentSpeed: 13.3, currentVsCleanPercent: 100, cpSpeed: 12.5, cpConsumption: 31.6, cleanPerformance: "Better Than CP", currentPerformance: "Better Than CP" },
    { condition: "ladenFull", cleanHullSpeed: 13.6, totalConsumption: 42.8, currentSpeed: 13.6, currentVsCleanPercent: 100, cpSpeed: 13.5, cpConsumption: 42.7, cleanPerformance: "Within + 0.5 kn", currentPerformance: "Within + 0.5 kn" },
    { condition: "ballastFull", cleanHullSpeed: 14.6, totalConsumption: 40.3, currentSpeed: 14.6, currentVsCleanPercent: 100, cpSpeed: 14, cpConsumption: 40.2, cleanPerformance: "Better Than CP", currentPerformance: "Better Than CP" },
  ],
  evaluation: { evaluatedDate: "2025-05-09", comment: "DD - July 2025. Performing okay" },
  voyageRows: [
    { refDate: "2025-04-20", voyageNumber: "V025", ladenDraft: 13.9, ladenSpeed: 12.5, ladenConsumption: 30.1, ladenAuxConsumption: 3.2, ladenDraftCorrectedSpeed: 12.4, ladenTotalConsumption: 33.3, ladenNormalizedConsumption: 32.9, ladenComment: "Good weather", ballastDraft: 7.1, ballastSpeed: 13.4, ballastConsumption: 28.6, ballastAuxConsumption: 3.2, ballastDraftCorrectedSpeed: 13.3, ballastTotalConsumption: 31.8, ballastNormalizedConsumption: 31.4, ballastComment: "Within curve" },
  ],
  noonReports: [
    { formGuid: "mock-form-guid", formLink: null, imoNumber: "9853890", vesselName: "CSSC AMSTERDAM", voyageNumber: "V025", date: "2025-04-20", reportType: "NOON", steamingHours: 24, location: "INDIAN OCEAN", vesselCondition: "LADEN", midDraft: 13.9, observedDistance: 298, mainEngineRpm: 74, mainEnginePowerPercent: 72, mainEnginePowerKw: null, specificFuelConsumption: 171, speedOverGround: 12.6, calculatedSpeedThroughWater: 12.5, reportedSpeedThroughWater: 12.4, totalMainEngineConsumption24h: 30.1, totalAuxConsumption24h: 3.2, totalConsumption24h: 33.3, windBeaufort: 3, combinedWaveHeight: 1.2, goodWeather: true, robIfo: 210, robLsf: 380, robLsg: 0, robMgo: 95, totalDgConsumption24h: 3.2, boilerConsumption24h: 0, distanceToGo: 1560, portName: null, slipPercent: -2.1, turboChargerRpm: 7600, hasScrubber: "True", scrubberStoppage: null, consumptionIfo: 0, consumptionLsf: 33.3, consumptionLsg: 0, consumptionMgo: 0, totalMainEngineConsumption: 30.1, mainEngineIfo: 0, mainEngineLsf: 30.1, mainEngineLsg: 0, mainEngineMgo: 0, totalAuxConsumption: 3.2, auxIfo: 0, auxLsf: 3.2, auxLsg: 0, auxMgo: 0, dg1Consumption: 1.1, dg2Consumption: 1.1, dg3Consumption: 1, boilerConsumption: 0, combinedWaveDirection: 45, windSpeed: 12, windDirection: 65, currentFactor: 0.1, seaWaterSalinity: 35, seaWaterTemperature: 27, noonSwell: 2, noonWindForce: 3, noonSeaState: 2, swellWaveDirection: 40, swellWaveHeight: 1, swellWavePeriod: 6, windSeaWaveDirection: 50, windSeaWaveHeight: 0.8, windSeaWavePeriod: 5 },
  ],
  hullEvents: [
    { date: "2025-03-10", event: "Underwater inspection", vendor: "Local approved vendor", place: "Singapore", comment: "No cleaning required" },
  ],
  dryDocks: [
    { dryDockDate: "2023-07-15", afAppliedDate: "2023-07-18", nextDryDock: "2028-07-15", paintSchemeFor: "5 years", place: "Zhoushan", paintVendor: "Jotun", bootTop: "SeaQuantum", flatBottom: "SeaForce", verticalSides: "SeaQuantum", propellerCoating: "PropSpeed", comment: "Completed" },
  ],
  chartSeries: [
    { date: "2025-04-18", voyageNumber: "V025", vesselCondition: "LADEN", speedThroughWater: 12.2, totalConsumption24h: 32.7, windBeaufort: 3, combinedWaveHeight: 1.1, goodWeather: true },
    { date: "2025-04-20", voyageNumber: "V025", vesselCondition: "LADEN", speedThroughWater: 12.5, totalConsumption24h: 33.3, windBeaufort: 3, combinedWaveHeight: 1.2, goodWeather: true },
  ],
  refreshedAt: "2025-05-09T09:00:00.000Z",
};

export const VESSEL_DATA_MOCK_DASHBOARDS: Record<string, VesselDataDashboard> = {
  "9853890": csscAmsterdamDashboard,
  "9460588": {
    ...csscAmsterdamDashboard,
    vessel: { ...csscAmsterdamDashboard.vessel, ...VESSEL_DATA_MOCK_VESSELS[1], vesselName: "SEA JUNO" },
    noonReports: csscAmsterdamDashboard.noonReports.map((report) => ({ ...report, imoNumber: "9460588", vesselName: "SEA JUNO" })),
  },
};
